const defaultConfig = {
  perPage: 4,
  perMove: 4,
  drag: true,
  autoplay: true,
  pauseOnHover: true,
  arrows: false,
  pagination: true,
  gap: '2rem',
  breakpoints: {
    920: {
      perPage: 3,
      gap: "1rem",
    },
    680: {
      perPage: 2,
    },
    420: {
      perPage: 2,
    },
  },
};

const specificConfig = {
  perPage: 3,
  perMove: 3,
  breakpoints: {
    920: {
      perPage: 3,
      gap: "1rem",
    },
    680: {
      perPage: 2,
    },
    420: {
      perPage: 1,
      padding: {right: '4rem' }
    },
  },
};

const shortVideoConfig = {
  perPage: 5,
  perMove: 1,
  drag: true,
  autoplay: false,
  arrows: false,
  pagination: true,
  gap: '0.75rem',
  breakpoints: {
    1200: {
      perPage: 4,
    },
    900: {
      perPage: 3,
      gap: '0.625rem',
    },
    600: {
      perPage: 2,
      gap: '0.5rem',
    },
    400: {
      perPage: 2,
      gap: '0.5rem',
      padding: { right: '1.5rem' },
    },
  },
};

var allElms = document.querySelectorAll('.splide');
var debattElms = document.querySelectorAll('.splide.debatt--carousel');
var shortVideoElms = document.querySelectorAll('.splide.short-video--carousel');

for (var i = 0; i < allElms.length; i++) {
  var el = allElms[i];
  if (!el.classList.contains('debatt--carousel') && !el.classList.contains('short-video--carousel')) {
    new Splide(el, defaultConfig).mount();
  }
}

for (var j = 0; j < debattElms.length; j++) {
  const mergedConfig = { ...defaultConfig, ...specificConfig };
  new Splide(debattElms[j], mergedConfig).mount();
}

for (var k = 0; k < shortVideoElms.length; k++) {
  new Splide(shortVideoElms[k], shortVideoConfig).mount();
}
